import React, { useState, useEffect, useMemo } from "react";
import { BsThreeDotsVertical } from "react-icons/bs";
import { Link } from "react-router-dom";
import DataTable, { createTheme } from "react-data-table-component";
import { useAtom } from "jotai";
import classes from "../../assets/styles/Contact.module.css";
import dummyImage from "../../assets/images/global_icons/dummyimage.svg";
import {
  USER,
  TEAMDETAIL,
  ASSIGN_MEMBER_ROLE,
  Card_URL,
  CARD_FEATURED,
} from "../../utils/constants/apiUrl";
import { get, deleteRecord, patch, post } from "../../server";
import showToast from "../../helpers/showToast";
import { loggedInUser, teamIDCheck } from "../../utils/store";
import Loader from "../../components/Loader";
import ConfirmationModal from "../../components/Modals/ConfirmationModal";
import FormInput from "../../components/Forms/FormInput";
import searchIcon from "../../assets/images/global_icons/searchicon.svg";
import formatPhoneNumber from "../../helpers/formatPhoneNumber";
import { Button, Image, Modal } from "react-bootstrap";
import baseURL from "../../utils/constants/baseUrl";
import { trackEvent } from "../../utils/mixpanel";
import CardView from "../../components/PageComponents/Function/Card";
import { getCardBrandingOverride } from "../../utils/cardBrandingOverrides";
import { formatDistanceToNow } from "date-fns";
import { AddMoreCustomUrls } from "../../utils/data/CardFunctionsData";
const TeamMembers = () => {
  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  const [userTeamId, setUserTeamId] = useAtom(teamIDCheck);
  const [loading, setLoading] = useState(true);

  const [teamMembers, setTeamMembers] = useState([]);
  const [deleteId, setDeleteId] = useState(null);

  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedMemberCards, setSelectedMemberCards] = useState([]);
  const [showCardView, setShowCardView] = useState(false);
  const [featuredCardIndex, setFeaturedCardIndex] = useState(0);
  const [featuredCardEnabled, setFeaturedCardEnabled] = useState(false);
  const [showAllMemberCards, setShowAllMemberCards] = useState(false);
  const [updatingFeaturedCard, setUpdatingFeaturedCard] = useState(false);

  const handleCloseCardView = () => {
    setShowCardView(false);
    setSelectedMemberCards([]);
    setFeaturedCardIndex(0);
    setFeaturedCardEnabled(false);
    setShowAllMemberCards(false);
  };

  const handleMemberRowClick = async (member) => {
    const memberFallbackCard = {
      id: null,
      card_type: "business",
      first_name: member.first_name || "",
      last_name: member.last_name || "",
      email: member.email || "",
      company: member.company || "",
      company_position: member.company_position || "",
      logo: "",
      background_image: "",
      profile_image: member.profile_image || "",
      color: "",
      country_phone: member.country_phone || "",
      phone_number: member.phone_number || "",
      description: member.description || "",
      address: member.address || "",
      city: member.city || "",
      state: member.state || "",
      country: member.country || "",
      website_url: member.website_url || "",
      status: true,
      is_featured: false,
      card_social_media: [],
      card_phone: member.phone_number
        ? [
            {
              phone_type: "mobile",
              country_phone: member.country_phone || "",
              phone_number: member.phone_number,
            },
          ]
        : [],
      content_view_type: "listDesign",
      profile_image_shape: "circle",
      logo_shape: loggedUser?.teams?.card_logo_shape || "circle",
      team: loggedUser?.teams || null,
    };
    setSelectedMemberCards([memberFallbackCard]);
    setFeaturedCardIndex(0);
    setFeaturedCardEnabled(false);
    setShowAllMemberCards(false);
    setShowCardView(true);
    const { status, data } = await get(
      `${Card_URL}?team_id=${member.team_id}&user_id=${member.user_id}`,
      loggedUser?.token || null
    );

    if (status && Array.isArray(data) && data.length > 0) {
      const memberCards = data.map((card) => {
        const socialMedia =
          card.card_social_media || card.cardSocialMedia || [];

        return {
          ...card,
          card_social_media: socialMedia.map((item) => {
            const mediaType = item.media_type || item.mediaType || "";
            const matchingMedia = AddMoreCustomUrls.find(
              (media) =>
                media.name.toLowerCase() === mediaType.toLowerCase() ||
                media.oldName.toLowerCase() === mediaType.toLowerCase()
            );

            return {
              ...item,
              media_type: mediaType,
              icon:
                mediaType.toLowerCase() === "custom"
                  ? "custom"
                  : matchingMedia?.icon || item.icon,
            };
          }),
          card_phone: card.card_phone || card.cardPhone || [],
          team: card.team || loggedUser?.teams || null,
        };
      });
      setSelectedMemberCards(memberCards);
      const featuredIndex = memberCards.findIndex(
        (card) => card.is_featured === true || card.is_featured === 1
      );
      setFeaturedCardIndex(featuredIndex >= 0 ? featuredIndex : 0);
      setFeaturedCardEnabled(featuredIndex >= 0);
      setShowAllMemberCards(false);
      trackEvent("Team Member Card Viewed", {
        team_id: member.team_id,
        user_id: member.user_id,
        card_ids: memberCards.map((card) => card.id),
        card_count: memberCards.length,
        source: "Team Members Table Row",
      });
    }
  };

  const handleFilter = (e) => {
    setFilterText(e.target.value);
  };

  const handleMemberCellClick = (event, member) => {
    event.preventDefault();
    event.stopPropagation();
    handleMemberRowClick(member);
  };

  const handleFeaturedCardChange = async (isFeatured) => {
    const selectedCard = selectedMemberCards[featuredCardIndex];
    if (!selectedCard?.id || updatingFeaturedCard) return;

    setUpdatingFeaturedCard(true);
    const { status, message } = await patch(
      CARD_FEATURED(selectedCard.id),
      { is_featured: isFeatured },
      loggedUser?.token || null
    );

    if (status) {
      setSelectedMemberCards((cards) =>
        cards.map((card, index) => ({
          ...card,
          is_featured: isFeatured && index === featuredCardIndex,
        }))
      );
      setFeaturedCardEnabled(isFeatured);
      setShowAllMemberCards(!isFeatured);
      showToast(status, message);
    } else {
      showToast(false, message || "Unable to update the featured card.");
    }

    setUpdatingFeaturedCard(false);
  };
  const getTeamMembers = async () => {
    setLoading(true);
    let { status, message, data } = await get(
      `${TEAMDETAIL}/${
        Object.keys(loggedUser).length !== 0 ? userTeamId : null
      }`,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );

    if (status) {
      const teamMembersData = data.team_members.map((member) => {
        const userData = member.user_data || {};

        return {
          ...userData,
          job_title: member.job_title ?? userData.job_title ?? "",
          last_active_at:
            member.last_active_at ??
            member.last_activity_at ??
            member.last_active ??
            userData.last_active_at ??
            userData.last_activity_at ??
            userData.last_active ??
            null,
          card_scan_count:
            member.card_scan_count ??
            member.qr_scan_count ??
            member.qr_code_scan_count ??
            member.function_qr_scan_count ??
            userData.card_scan_count ??
            userData.qr_scan_count ??
            userData.qr_code_scan_count ??
            userData.function_qr_scan_count ??
            null,
          latest_qrcode_share_activity:
            member.latest_qrcode_share_activity ??
            userData.latest_qrcode_share_activity ??
            null,
          latest_nfc_activity:
            member.latest_nfc_activity ??
            userData.latest_nfc_activity ??
            null,
          team_id: member.team_id,
          user_id: member.user_id,
          is_admin: member.is_admin,
          member_id: member.id,
        };
      });
      setTeamMembers(teamMembersData);
    } else {
      showToast(status, message);
    }
    setLoading(false);
  };

  useEffect(() => {
    getTeamMembers();
  }, []);

  const getLastActiveText = (lastActiveAt) => {
    if (!lastActiveAt) return "-";

    const parsedDate = new Date(lastActiveAt);
    if (Number.isNaN(parsedDate.getTime())) {
      const activeText = String(lastActiveAt).replace(/^active\s*/i, "");
      return activeText || "-";
    }

    return formatDistanceToNow(parsedDate, { addSuffix: true });
  };

  const getActivityTime = (createdAt) => {
    if (!createdAt) return "-";

    const parsedDate = new Date(createdAt);
    if (Number.isNaN(parsedDate.getTime())) return createdAt;

    const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const localDate = parsedDate.toLocaleDateString([], {
      timeZone: localTimeZone,
      year: "numeric",
      month: "short",
      day: "numeric",
    });
    const localTime = parsedDate.toLocaleTimeString([], {
      timeZone: localTimeZone,
      hour: "2-digit",
      minute: "2-digit",
    });

    return (
      <>
        <span className="d-block">{localDate}</span>
        <span className="d-block">{localTime}</span>
      </>
    );
  };

  const filteredItems = useMemo(() => {
    const filtered = teamMembers.filter(
      (item) =>
        `${item.first_name || ""} ${item.last_name || ""}`
          .toLowerCase()
          .includes(filterText.toLowerCase()) ||
        `${item.email || ""}`
          .toLowerCase()
          .includes(filterText.toLowerCase()) ||
        `${item.city || ""}`.toLowerCase().includes(filterText.toLowerCase()) ||
        `${item.country || ""}`
          .toLowerCase()
          .includes(filterText.toLowerCase()) ||
        `${item.country_phone ? `+${item.country_phone}` : ""}${
          item.phone_number || ""
        }`.includes(filterText) ||
        `${item.is_admin == 1 ? "yes" : "no" || ""}`
          .toLowerCase()
          .includes(filterText.toLowerCase())
    );

    return filtered;
  }, [filterText, teamMembers]);

  createTheme(
    "solarized",
    {
      background: {
        default: "background: var(--secondary_color)",
      },
    },
    "dark"
  );

  const columns = [
    {
      name: "Name",
      width: "15%",
      cell: (row) => (
        <div
          className="profileWrapper w-100 h-100"
          role="button"
          tabIndex={0}
          onClick={(event) => handleMemberCellClick(event, row)}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              handleMemberCellClick(event, row);
            }
          }}
        >
          <Image
            src={`${baseURL.PUBLIC_URL}${row.profile_image}` || dummyImage}
            roundedCircle={true}
            loading="lazy"
            decoding="async"
            width="50px"
            height="50px"
            onError={(e) => {
              e.currentTarget.src = dummyImage;
            }}
          />
          <div>
            <p className="globalName">
              {row.first_name} {row.last_name}
            </p>
          </div>
        </div>
      ),
    },
    {
      name: "Email",
      width: "11%",
      cell: (row) => (
        <a
          href={`mailto:${row.email}`}
          className="globalDetail"
          style={{ display: "block", width: "100%" }}
          onClick={(event) => handleMemberCellClick(event, row)}
        >
          {row.email}
        </a>
      ),
    },
    {
      name: "Job Title",
      width: "9%",
      cell: (row) => (
        <p
          className="globalDetail w-100"
          onClick={(event) => handleMemberCellClick(event, row)}
        >
          {row.job_title || "-"}
        </p>
      ),
    },
    {
      name: "Last Active",
      width: "12%",
      cell: (row) => (
        <div
          className="globalDetail w-100"
          onClick={(event) => handleMemberCellClick(event, row)}
        >
          {row.last_active_at ? (
            <div>
              <div className="d-flex align-items-center gap-2">
                <span
                  aria-hidden="true"
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    backgroundColor: "#20b994",
                    flexShrink: 0,
                  }}
                />
                <span>Active</span>
              </div>
              <small style={{ color: "#8b949e" }}>
                {getLastActiveText(row.last_active_at)}
              </small>
            </div>
          ) : (
            <div>
              <div className="d-flex align-items-center gap-2">
                <span
                  aria-hidden="true"
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    backgroundColor: "#8b949e",
                    flexShrink: 0,
                  }}
                />
                <span>Inactive</span>
              </div>
              <small style={{ color: "#8b949e" }}>Invite pending</small>
            </div>
          )}
        </div>
      ),
    },
    {
      name: "QR Scan",
      width: "9%",
      cell: (row) => (
        <p
          className="globalDetail w-100"
          onClick={(event) => handleMemberCellClick(event, row)}
        >
          {getActivityTime(row.latest_qrcode_share_activity?.created_at)}
        </p>
      ),
    },
    {
      name: "NFC Scan",
      width: "9%",
      cell: (row) => (
        <p
          className="globalDetail w-100"
          onClick={(event) => handleMemberCellClick(event, row)}
        >
          {getActivityTime(row.latest_nfc_activity?.created_at)}
        </p>
      ),
    },
    {
      name: "Phone Number",
      width: "11%",
      cell: (row) => (
        <>
          {row.phone_number ? (
            <a
              href={`tel:${
                row.country_phone
                  ? "+" +
                    row.country_phone +
                    " " +
                    formatPhoneNumber(row.phone_number)
                  : row.phone_number || ""
              }`}
              className="globalDetail"
              onClick={(event) => handleMemberCellClick(event, row)}
            >
              {row.country_phone
                ? "+" +
                  row.country_phone +
                  " " +
                  formatPhoneNumber(row.phone_number)
                : row.phone_number || ""}
            </a>
          ) : (
            <p
              className="globalDetail w-100"
              onClick={(event) => handleMemberCellClick(event, row)}
            >
              -
            </p>
          )}
        </>
      ),
    },
    {
      width: "8%",
      name: "City, Country",
      cell: (row) => (
        <>
          {row.city || row.country ? (
            <a
              href={`http://maps.google.com/?q=${row.city || ""}${
                row.city && row.country ? ", " : ""
              }${row.country || " "}`}
              className="globalDetail"
              target="_blank"
              rel="noreferrer"
              onClick={(event) => handleMemberCellClick(event, row)}
            >
              {row.city || ""}
              {row.city && row.country ? "," : ""} {row.country}
            </a>
          ) : (
            <p
              className="globalDetail w-100"
              onClick={(event) => handleMemberCellClick(event, row)}
            >
              -
            </p>
          )}
        </>
      ),
    },
    {
      name: "Is Admin",
      width: "8%",
      cell: (row) => (
        <p
          className="globalDetail w-100"
          style={{ whiteSpace: "nowrap" }}
          onClick={(event) => handleMemberCellClick(event, row)}
        >
          {row.is_admin ? "Yes" : "No"}
        </p>
      ),
    },
    {
      name: "Action",
      width: "8%",
      right: "true",
      ignoreRowClick: true,
      button: true,
      cell: (row) => (
        <div className="action">
          <button
            className="btn customActionDropdown dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <BsThreeDotsVertical className={"globalVerticalThreeDots"} />
          </button>
          <ul className="customActionDropdownMenu dropdown-menu dropdown-menu-end ">
            <li>
              <Link
                className="dropdown-item"
                to={`/team/teamMembers/addEditTeamMember/${row.user_id}`}
              >
                Edit
              </Link>
            </li>
            <li>
              <Link
                className="dropdown-item"
                to={`/team/${row.team_id}/teamMembers/member/${row.user_id}/function?member_admin=${row.is_admin === true || Number(row.is_admin) === 1 ? 1 : 0}`}
                state={{
                  selectedMemberIsAdmin:
                    row.is_admin === true || Number(row.is_admin) === 1,
                }}
                onClick={() =>
                  trackEvent("Team Member Functions Viewed", {
                    team_id: row.team_id,
                    user_id: row.user_id,
                    source: "Team Members Table",
                  })
                }
              >
                Functions
              </Link>
            </li>
            <li>
              <span
                className="dropdown-item"
                onClick={() => handleMemberAdmin(row)}
              >
                {row.is_admin ? "Remove as Admin" : "Mark as Admin"}
              </span>
            </li>
            <li>
              <span
                className="dropdown-item"
                style={{ color: "#E35252" }}
                onClick={() => handleDelete(row.id)}
              >
                Remove from team
              </span>
            </li>
          </ul>
        </div>
      ),
    },
  ];
  // Handle confirmation modal
  const handleShowConfirmationModal = () => setShowConfirmationModal(true);
  const handleCloseConfirmationModal = () => setShowConfirmationModal(false);

  // handle delete
  const handleDelete = (id) => {
    trackEvent("Delete Attempted from Team Member", {
      item_id: id,
      triggered_by: loggedUser?.id,
    });
    setDeleteId(id);
    handleShowConfirmationModal(true);
  };

  const handleConfirmDelete = async () => {
    handleCloseConfirmationModal(true);
    setLoading(true);

    let { status, message } = await deleteRecord(
      `${USER}/${deleteId}?team_id=${userTeamId}`,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    showToast(status, message);

    await getTeamMembers();
    setLoading(false);
  };

  // Handle member admin Role
  const handleMemberAdmin = async (data) => {
    setLoading(true);
    trackEvent("Admin Status Toggled in Team", {
      user_id: data.user_id || data.member_id,
      team_id: data.team_id,
      action: data.is_admin ? "Removed as Admin" : "Marked as Admin",
      triggered_by: loggedUser?.id,
    });
    let { status, message } = await post(
      `${ASSIGN_MEMBER_ROLE}/${data.member_id}`,
      { make_admin: !data.is_admin },
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    showToast(status, message);
    await getTeamMembers();
    setLoading(false);
  };

  const totalPages = Math.ceil(filteredItems.length / perPage);
  const paginatedItems = filteredItems.slice(
    (currentPage - 1) * perPage,
    currentPage * perPage
  );

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage) => {
    setPerPage(newPerPage);
    setCurrentPage(1);
  };

  return (
    <>
      {!loading ? (
        <div className="">
          <div className="page_Header">
            <div className="d-flex justify-content-between align-items-md-center align-items-initial flex-md-row flex-column gap-3">
              <div className="heading">
                <h1>
                  Team Members <span>({teamMembers.length})</span>
                </h1>
              </div>
              {/* <div className="d-flex align-items-center justify-content-between gap-2">
                <Link
                  className="addMemberButton"
                  to={`/team/teamMembers/addEditTeamMember`}
                  onClick={() => {
                    trackEvent("Team Member Add Clicked", {
                      source: "Team Members Page",
                      action: "Navigated to Add Member",
                    });
                  }}
                >
                  Add Member
                </Link>
                <FormInput
                  icon={searchIcon}
                  placeholder="Search..."
                  value={filterText}
                  handleChange={handleFilter}
                />
              </div> */}

              <div className="d-flex align-items-center justify-content-between gap-2 mobileViewWrapper">
                {/* <FormInput
    icon={searchIcon}
    placeholder="Search..."
    value={filterText}
    handleChange={handleFilter}
  /> */}
                <div
                  className="input-group"
                  style={{ maxWidth: "250px", height: "45px" }}
                >
                  <span className="input-group-text bg-white border-end-0">
                    <img
                      src={searchIcon}
                      alt="search"
                      style={{ height: "16px" }}
                    />
                  </span>
                  <input
                    type="text"
                    className="form-control border-start-0"
                    placeholder="Search..."
                    value={filterText}
                    onChange={handleFilter}
                  />
                </div>
                <Link
                  to={`/team/teamMembers/addEditTeamMember`}
                  onClick={() => {
                    trackEvent("Team Member Add Clicked", {
                      source: "Team Members Page",
                      action: "Navigated to Add Member",
                    });
                  }}
                >
                  <Button variant="primary">Add Member</Button>
                </Link>
              </div>
            </div>
          </div>
          <div className="default-list-table">
            <DataTable
              columns={columns}
              data={paginatedItems}
              theme="solarized"
              onRowClicked={handleMemberRowClick}
              pointerOnHover
              highlightOnHover
            />
            <div className="d-flex justify-content-center align-items-center p-3 flex-wrap gap-4 border-top">
              <div className="d-flex align-items-center gap-2">
                <span className="globalDetail">Rows per page:</span>
                <select
                  className="form-select"
                  style={{ width: "auto", padding: "6px 35px 6px 12px" }}
                  value={perPage}
                  onChange={(e) => handlePerRowsChange(Number(e.target.value))}
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
              </div>

              <nav aria-label="Page navigation">
                <ul className="pagination mb-0">
                  <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(currentPage - 1)}
                      style={{
                        padding: "8px 16px",
                        minWidth: "45px",
                        textAlign: "center",
                        color: "#58a388",
                      }}
                    >
                      &laquo; Previous
                    </button>
                  </li>

                  {(() => {
                    const pages = [];
                    if (totalPages <= 0) {
                      // no data yet
                    } else if (totalPages <= 8) {
                      for (let i = 1; i <= totalPages; i++) pages.push(i);
                    } else {
                      if (currentPage <= 4) {
                        for (let i = 1; i <= 6; i++) pages.push(i);
                        pages.push("ellipsis-end");
                        pages.push(totalPages);
                      } else if (currentPage >= totalPages - 3) {
                        pages.push(1);
                        pages.push("ellipsis-start");
                        for (let i = totalPages - 5; i <= totalPages; i++)
                          pages.push(i);
                      } else {
                        pages.push(1);
                        pages.push("ellipsis-start");
                        pages.push(currentPage - 1);
                        pages.push(currentPage);
                        pages.push(currentPage + 1);
                        pages.push("ellipsis-end");
                        pages.push(totalPages);
                      }
                    }

                    return pages.map((page, index) => {
                      if (typeof page === "string") {
                        return (
                          <li
                            key={`ellipsis-${index}`}
                            className="page-item disabled"
                          >
                            <span
                              className="page-link"
                              style={{
                                padding: "8px 16px",
                                minWidth: "45px",
                                textAlign: "center",
                                color: "#58a388",
                              }}
                            >
                              ...
                            </span>
                          </li>
                        );
                      }
                      return (
                        <li
                          key={page}
                          className={`page-item ${currentPage === page ? "active" : ""}`}
                        >
                          <button
                            className="page-link"
                            onClick={() => handlePageChange(page)}
                            style={{
                              backgroundColor: currentPage === page ? "#58a388" : "",
                              borderColor: currentPage === page ? "#58a388" : "",
                              color: currentPage === page ? "#fff" : "#58a388",
                              padding: "8px 16px",
                              minWidth: "45px",
                              textAlign: "center",
                            }}
                          >
                            {page}
                          </button>
                        </li>
                      );
                    });
                  })()}

                  <li
                    className={`page-item ${
                      currentPage === totalPages || filteredItems.length === 0
                        ? "disabled"
                        : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(currentPage + 1)}
                      style={{
                        padding: "8px 16px",
                        minWidth: "45px",
                        textAlign: "center",
                        color: "#58a388",
                      }}
                    >
                      Next &raquo;
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
          <ConfirmationModal
            show={showConfirmationModal}
            handleCloseModal={handleCloseConfirmationModal}
            handleConfirmDelete={handleConfirmDelete}
            confirmTitle="user"
            isRemoveMemberMessage={true}
          />
          <Modal
            show={showCardView}
            onHide={handleCloseCardView}
            aria-labelledby="contained-modal-title-vcenter"
            className="customModal square-modal cardViewModal team-member-card-view-modal"
          >
            <Modal.Header closeButton>
              <Modal.Title>Card Views ({selectedMemberCards.length})</Modal.Title>
            </Modal.Header>
            <Modal.Body
              style={{
                maxHeight: "80vh",
                overflowY: "auto",
                overflowX: "hidden",
              }}
            >
              <div className="featured-card-toolbar">
                <div>
                  <strong>Featured card</strong>
                  <span className="featured-card-count">
                    {selectedMemberCards.length
                      ? `${featuredCardIndex + 1} of ${selectedMemberCards.length}`
                      : "0 of 0"}
                  </span>
                </div>
                <label className="featured-card-switch">
                  <input
                    type="checkbox"
                    checked={featuredCardEnabled}
                    disabled={updatingFeaturedCard}
                    onChange={(event) =>
                      handleFeaturedCardChange(event.target.checked)
                    }
                  />
                  <span />
                </label>
              </div>

              {!showAllMemberCards && selectedMemberCards.length > 0 ? (
                <>
                  <div className="featured-card-main">
                    <CardView
                      data={selectedMemberCards[featuredCardIndex]}
                      showSidebar={false}
                      hideHeader={true}
                      showCountryCodeSeparate={true}
                      inViewMode={true}
                    />
                  </div>

                  {selectedMemberCards.length > 1 && (
                    <div className="other-member-cards">
                      <div className="other-member-cards-title">
                        Other cards
                        <span>{selectedMemberCards.length - 1} cards</span>
                      </div>
                      <div className="other-member-cards-scroll">
                        {selectedMemberCards.map((card, index) => {
                          if (index === featuredCardIndex) return null;
                          const cardBrandingOverride =
                            getCardBrandingOverride(card.id, card.uuid);
                          const thumbnail =
                            cardBrandingOverride.background_image ||
                            card.background_image ||
                            card.team?.card_background_image;
                          const thumbnailUrl = thumbnail
                            ? thumbnail.startsWith("http") ||
                              thumbnail.startsWith("data:")
                              ? thumbnail
                              : `${baseURL.PUBLIC_URL}${thumbnail}`
                            : dummyImage;

                          return (
                            <button
                              type="button"
                              className="other-member-card-button"
                              key={card.id || index}
                              onClick={() => {
                                setFeaturedCardIndex(index);
                                setFeaturedCardEnabled(
                                  card.is_featured === true ||
                                    card.is_featured === 1
                                );
                                setShowAllMemberCards(false);
                              }}
                              aria-label={`Show ${
                                `${card.first_name || ""} ${card.last_name || ""}`.trim() ||
                                card.card_type ||
                                `card ${index + 1}`
                              } as featured card`}
                            >
                              <img src={thumbnailUrl} alt="" />
                              <span className="other-member-card-label">
                                {`${card.first_name || ""} ${card.last_name || ""}`.trim() ||
                                  card.card_type ||
                                  `Card ${index + 1}`}
                              </span>
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <div className="row g-4">
                  {selectedMemberCards.map((card, index) => (
                    <div className="col-12" key={card.id || index}>
                      <CardView
                        data={card}
                        showSidebar={false}
                        hideHeader={true}
                        showCountryCodeSeparate={true}
                        inViewMode={true}
                      />
                    </div>
                  ))}
                </div>
              )}
            </Modal.Body>
          </Modal>
        </div>
      ) : (
        <Loader />
      )}

      <style type="text/css">
        {`
          .profileWrapper {
            display: flex;
            align-items: center;
            gap: 20px;
          }
          .profileWrapper img {
            border: 2px solid var(--primary_text_color);
          }

          .featured-card-toolbar {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 16px;
            padding: 14px 18px;
            margin-bottom: 12px;
            border-radius: 14px;
            background: var(--tertiary_color, #f4a83a);
            box-shadow: 0 5px 14px rgba(0, 0, 0, 0.16);
          }
          .featured-card-count {
            margin-left: 10px;
            padding: 3px 8px;
            border-radius: 12px;
            font-size: 12px;
            background: rgba(255, 255, 255, 0.24);
          }
          .featured-card-switch input { display: none; }
          .featured-card-switch span {
            display: block;
            position: relative;
            width: 42px;
            height: 24px;
            border-radius: 20px;
            cursor: pointer;
            background: #a8a8a8;
            transition: 0.2s ease;
          }
          .featured-card-switch span:after {
            content: "";
            position: absolute;
            top: 3px;
            left: 3px;
            width: 18px;
            height: 18px;
            border-radius: 50%;
            background: #fff;
            transition: 0.2s ease;
          }
          .featured-card-switch input:checked + span {
            background: var(--primary_button_color, #22a081);
          }
          .featured-card-switch input:checked + span:after {
            transform: translateX(18px);
          }
          .featured-card-main {
            max-width: 590px;
            margin: 0 auto 16px;
          }
          .team-member-card-view-modal .mainDiv-new {
            margin: 0 !important;
          }
          .team-member-card-view-modal .outerWrapper-new {
            min-height: 0 !important;
            padding: 0 !important;
          }
          .team-member-card-view-modal .modal-content {
            overflow: hidden;
          }
          .team-member-card-view-modal .modal-body {
            overscroll-behavior: contain;
            scrollbar-gutter: stable;
          }
          .team-member-card-view-modal .featured-card-main,
          .team-member-card-view-modal .featured-card-main .mainDiv-new {
            width: 100% !important;
            max-width: 100% !important;
            min-width: 0 !important;
          }
          .other-member-cards {
            position: relative;
            width: 100%;
            max-width: 100%;
            overflow: hidden;
            padding: 12px 0 2px;
            background: var(--table-color, #fff);
            border-top: 1px solid var(--border-color, #ddd);
          }
          .other-member-cards-title {
            display: flex;
            justify-content: space-between;
            margin-bottom: 8px;
            font-weight: 600;
          }
          .other-member-cards-title span { font-size: 12px; font-weight: 400; }
          .other-member-cards-scroll {
            display: flex;
            width: 100%;
            max-width: 100%;
            gap: 12px;
            overflow-x: auto;
            overflow-y: hidden;
            padding: 4px 3px 12px;
            scroll-snap-type: x proximity;
            scroll-behavior: smooth;
            scrollbar-width: thin;
            scrollbar-color: var(--primary_button_color, #22a081) transparent;
          }
          .other-member-cards-scroll::-webkit-scrollbar {
            height: 6px;
          }
          .other-member-cards-scroll::-webkit-scrollbar-track {
            border-radius: 10px;
            background: rgba(127, 127, 127, 0.12);
          }
          .other-member-cards-scroll::-webkit-scrollbar-thumb {
            border-radius: 10px;
            background: var(--primary_button_color, #22a081);
          }
          .other-member-card-button {
            position: relative;
            width: 155px;
            min-width: 155px;
            height: 102px;
            padding: 0;
            overflow: hidden;
            border: 2px solid transparent;
            border-radius: 12px;
            background: var(--table-color, #fff);
            color: var(--dynamic-text-color, #222);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.16);
            scroll-snap-align: start;
            transition: transform 0.2s ease, border-color 0.2s ease,
              box-shadow 0.2s ease;
          }
          .other-member-card-button:hover,
          .other-member-card-button:focus-visible {
            transform: translateY(-2px);
            border-color: var(--primary_button_color, #22a081);
            box-shadow: 0 7px 16px rgba(0, 0, 0, 0.22);
            outline: none;
          }
          .other-member-card-button img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          .other-member-card-label {
            position: absolute;
            right: 0;
            bottom: 0;
            left: 0;
            display: block;
            padding: 16px 8px 7px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 12px;
            font-weight: 600;
            color: #fff;
            text-align: left;
            background: linear-gradient(transparent, rgba(0, 0, 0, 0.78));
          }

	      `}
      </style>
    </>
  );
};

export default TeamMembers;
